/* eslint-disable @typescript-eslint/no-non-null-assertion */
import * as React from 'react';
import styled from 'styled-components';
import { ITextStyleProps, IHeadingStyleProps, TextStyleType, HeadingStyleType } from './typography-components-props';
import { typographyPresets } from './typography-components-styles';

const TypographedText = styled.span<{ $textStyle: TextStyleType; }>`
    ${({ $textStyle }) => typographyPresets.textStyles[$textStyle]};
`;

const TypographedHeading = styled.div<{ $headingStyle: HeadingStyleType; }>`
    ${({ $headingStyle }) => typographyPresets.headings[$headingStyle]};
    margin: 0;
`;

const TextStyleComponents = {
    XSmall: 'xSmall',
    Small: 'small',
    LightSmall: 'lightSmall',
    Medium: 'medium',
    Large: 'large',
    XLarge: 'xLarge',
    SectionHeading: 'sectionHeading',
    Hero1: 'hero1',
    Hero2: 'hero2',
    Hero3: 'hero3',
    Hero4: 'hero4',
    Hero5: 'hero5'
};

const HeadingStyleComponents = {
    H1: 'h1',
    H2: 'h2',
    H3: 'h3',
    H4: 'h4',
    H5: 'h5',
    H6: 'h6'
};

type TypographicTextComponentNames = keyof typeof TextStyleComponents;
type TypographicHeadingComponentNames = keyof typeof HeadingStyleComponents;

type TypographicTextComponents = {
    [key in TypographicTextComponentNames]: React.ComponentType<ITextStyleProps>;
};
type TypographicHeadingComponents = {
    [key in TypographicHeadingComponentNames]: React.ComponentType<IHeadingStyleProps>;
};

export type TypographicComponents = TypographicTextComponents & TypographicHeadingComponents;

const asTypoText = (name: string, styleName?: TextStyleType) => {
    // eslint-disable-next-line react/prop-types
    const temp = React.forwardRef<HTMLSpanElement>(({ className, children, hidden, ...rest }: ITextStyleProps, ref) => (hidden ? null : (
        <TypographedText {...rest} className={className} $textStyle={styleName!} ref={ref}>
            {children}
        </TypographedText>
    )));

    temp.displayName = name;
    return temp as React.ComponentType<ITextStyleProps>;
};

const asTypoHeading = (name: string, headingStyleName?: HeadingStyleType) => {
    // eslint-disable-next-line react/prop-types
    const temp = React.forwardRef<HTMLDivElement>(({ className, children, hidden, ...rest }: IHeadingStyleProps, ref) => (hidden ? null : (
        <TypographedHeading {...rest} as={headingStyleName} className={className} $headingStyle={headingStyleName!} ref={ref}>
            {children}
        </TypographedHeading>
    )));

    temp.displayName = name;
    return temp as React.ComponentType<IHeadingStyleProps>;
};

export const Typography: TypographicComponents = {} as any;

Object.entries(TextStyleComponents).forEach(([name, styleName]) => {
    Typography[name as TypographicTextComponentNames] = asTypoText(name, styleName as TextStyleType);
});

Object.entries(HeadingStyleComponents).forEach(([name, headingStyleName]) => {
    Typography[name as TypographicHeadingComponentNames] = asTypoHeading(name, headingStyleName as HeadingStyleType);
});
